import { TitlelessCard, Icon, IconDefinitions, SpinnerDefault, LiveBadge } from '../../../../components';
import { Badge } from 'react-bootstrap';
import { GaugeConfig, UploadSessionModel, UploadSessionStatus } from '../../../../data/entities';
import { UploadProgressCard } from './UploadProgressCard';

interface Props {
  activeSessions: UploadSessionModel[];
  loadingActive: boolean;
  gaugeConfigResolver: (session: UploadSessionModel) => GaugeConfig | null;
}

export function ActiveUploadsSection({ activeSessions, loadingActive, gaugeConfigResolver }: Props) {
  if (loadingActive) {
    return (
      <div className="text-center py-5 mb-4">
        <SpinnerDefault />
        <p className="text-muted mt-2 small">Loading sessions...</p>
      </div>
    );
  }

  return (
    <TitlelessCard className="mb-4">
      <div className="d-flex align-items-center mb-3">
        <h6 className="mb-0">
          <Icon iconName={IconDefinitions.chartLineUp} className="me-2 text-primary" />
          Active Uploads
        </h6>
        {activeSessions.length > 0 && (
          <>
            <Badge bg="primary" className="ms-2">
              {activeSessions.length}
            </Badge>
            <span className="ms-2">
              <LiveBadge />
            </span>
          </>
        )}
      </div>

      {activeSessions.length === 0 ? (
        <div className="text-center py-4">
          <Icon
            iconName={IconDefinitions.circleCheck}
            className="text-success mb-2"
            style={{ fontSize: '1.5rem' }}
          />
          <p className="text-muted mb-0 small">No active uploads</p>
        </div>
      ) : (
        <div className="row g-3">
          {activeSessions
            .sort((a, b) => {
              if (a.status === UploadSessionStatus.InProgress && b.status === UploadSessionStatus.Queued) return -1;
              if (a.status === UploadSessionStatus.Queued && b.status === UploadSessionStatus.InProgress) return 1;
              return 0;
            })
            .map((s) => (
              <UploadProgressCard 
                key={s.id} 
                session={s} 
                gaugeConfig={gaugeConfigResolver(s)} 
              />
            ))}
        </div>
      )}
    </TitlelessCard>
  );
}